// src/app/pages/dashboard/Apps/InvoiceProcessingWrapper.tsx

import React, { useState, useRef, useEffect, FC, useCallback, useMemo } from 'react';
import { Dialog } from 'primereact/dialog';
import axios from 'axios';
import { Button } from 'primereact/button';
import { API_URL } from '../../../modules/auth/core/_requests';
import { PageTitle } from '../../../../_designereyes/layout/core';       // PrimeReact Theme
import 'primereact/resources/primereact.min.css';               // PrimeReact Core CSS
import 'primeicons/primeicons.css';                             // PrimeReact Icons
import { Toast } from 'primereact/toast';                       // Import PrimeReact's Toast
import './ProductImagesReviewerWrapper.css';
import { TabView, TabPanel } from 'primereact/tabview'; // Add this import
import { InputText } from 'primereact/inputtext'; // Add this import
import { Dropdown } from 'primereact/dropdown';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';

const IMAGE_NOT_FOUND_URL = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTAiIGhlaWdodD0iNzUiIHZpZXdCb3g9IjAgMCAxNTAgNzUiPjxyZWN0IHdpZHRoPSIxNTAiIGhlaWdodD0iNzUiIGZpbGw9IiNmMGYwZjAiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEycHgiIGZpbGw9IiM5OTkiPkltYWdlIE5vdCBGb3VuZDwvdGV4dD48L3N2Zz4=';
const BASE_SFTP_RAW_PATH = 'images2.designereyes.com/ftp/raw'
const BASE_SFTP_PROCESSED_PATH = 'images2.designereyes.com/ftp/processed'

const IMAGE_TYPE_MAPPING = {
  'Front': 'P01',
  'Angled': 'P02',
  'Side': 'P03',
};


const categoryOptions: ImageCategory[] = [
  { label: 'Keep Original Information', value: '' },
  { label: 'Product', value: 'product_image' },
  { label: 'Lifestyle', value: 'lifestyle_image' },
];


const typeOptions: ImageType[] = [
  { label: 'Keep Original Information', value: '' },
  { label: 'Front', value: 'Front' },
  { label: 'Angled', value: 'Angled' },
  { label: 'Side', value: 'Side' },
  { label: 'Extra', value: 'Extra' },
];


const hitsOptions = [
  { label: '10 results', value: 10 },
  { label: '25 results', value: 25 },
  { label: '50 results', value: 50 },
  { label: '100 results', value: 100 },
  { label: '250 results', value: 250 },
  { label: '500 results', value: 500 },
  { label: '1000 results', value: 1000 },
  { label: 'All results', value: 99999 },
];

const searchTypeOptions = [
  { label: 'All Types', value: 'All' },
  { label: 'Front', value: 'Front' },
  { label: 'Angled', value: 'Angled' },
  { label: 'Side', value: 'Side' },
  { label: 'Extra', value: 'Extra' },
];


interface LoadedImageMetadata {
  ImageID: number;
  file_name: string;
  original_file_path: string;
  URL: string;
  status: string;
  brand?: string;
  model?: string;
  color_code?: string;
  upc?: string;
  size_code?: string;
  image_type?: string;
  image_category: string;
  ImageWidth?: number | undefined;
  ImageHeight?: number | undefined;
  error_reason?: string;
}

interface GeneratedImageMetadata {
  ImageID: number;
  original_file_path: string;
  URL: string;
  status: string;
  image_category: string;
  image_width: number | undefined;
  image_height: number | undefined;
  brand: string;
  model: string;
  color_code: string;
  upc: string;
  size_code: string;
  generated_file_name: string;
  generated_image_type: string;
  generated_image_number: string;
  generated_file_path: string;
  generated_url: string;
}

interface ImageCategory {
  label: string;
  value: string;
}

interface ImageType {
  label: string;
  value: string;
}

interface DuplicateData {
  ImageID: number;
  file_name: string;
  file_path: string;
  URL: string;
  image_type: string;
  image_category: string;
  status: string;
  brand?: string;
  model?: string;
}

interface DuplicateResult {
  imageData: GeneratedImageMetadata;
  success: boolean;
  error?: string;
  requiresConfirmation?: boolean;
  skipped?: boolean;
  reason?: string;
}

interface DuplicateDialogData {
  imageData: GeneratedImageMetadata;
  duplicateData: DuplicateData;
}


const ProductImagesReviewer: FC = () => {
  // Separate states for each type of images
  const [reviewImages, setReviewImages] = useState<LoadedImageMetadata[]>([]);
  const [reviewedImages, setReviewedImages] = useState<LoadedImageMetadata[]>([]);
  const [cleanedImages, setCleanedImages] = useState<LoadedImageMetadata[]>([]);
  const [selectedImages, setSelectedImages] = useState<LoadedImageMetadata[]>([]);
  const [failedImages, setFailedImages] = useState<LoadedImageMetadata[]>([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const toast = useRef<Toast>(null);
 /// const [searchResults, setSearchResults] = useState<LoadedImageMetadata[]>([]); // Add this state
  const [searchTerm, setSearchTerm] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const [baseFileNameInput, setBaseFileNameInput] = useState('');
  const [offsets, setOffsets] = useState({
    review: 0,
    reviewed: 0,
    cleaned: 0,
    failed: 0
  });
  const ROWS_PER_PAGE = 10;
  const [hasMore, setHasMore] = useState<{ [key: string]: boolean }>({
    review: true,
    reviewed: true,
    cleaned: true,
    failed: true
  });
  const [loadingMore, setLoadingMore] = useState(false);
  const [searchDialogVisible, setSearchDialogVisible] = useState(false);
  const [reviewDialogVisible, setReviewDialogVisible] = useState(false);
  const [ignoreDuplicates, setIgnoreDuplicates] = useState(false);
  const [markAsReviewed, setMarkAsReviewed] = useState(true);
  const [reviewMetadata, setReviewMetadata] = useState<GeneratedImageMetadata[]>([]);
  const [reviewLoading, setReviewLoading] = useState(false);
  const [currentDuplicate, setCurrentDuplicate] = useState<DuplicateDialogData | null>(null);
  const [duplicateQueue, setDuplicateQueue] = useState<DuplicateResult[]>([]);
  const [showDuplicateDialog, setShowDuplicateDialog] = useState(false);
  const [searchHits, setSearchHits] = useState<number>(10);
  const [applyingChanges, setApplyingChanges] = useState(false);
  const [deletingImages, setDeletingImages] = useState(false);
  const [keepingNewImage, setKeepingNewImage] = useState(false);
  const [keepingOriginalImage, setKeepingOriginalImage] = useState(false);
  const [totalRecords, setTotalRecords] = useState({
    review: 0,
    reviewed: 0,
    cleaned: 0,
    failed: 0
  });
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(7);
  const [loadingDuplicateData, setLoadingDuplicateData] = useState(false);
  const [searchImageType, setSearchImageType] = useState('All');
  const [applyToAllDuplicates, setApplyToAllDuplicates] = useState(false);
  const isFailedTab = useMemo(() => activeTab === 3, [activeTab]);


const onPage = (event: any) => {
    setFirst(event.first);
    setRows(event.rows);
  };

const handleDelete = async () => {
  if (selectedImages.length === 0) return;

  confirmDialog({
    message: `Are you sure you want to delete ${selectedImages.length} image(s)?`,
    header: 'Delete Confirmation',
    icon: 'pi pi-exclamation-triangle',
    accept: async () => {
      try {
        setDeletingImages(true);
        const response = await axios.post(`${API_URL}/api/product-images/reviewer/delete-images`, {
          images: selectedImages.map(img => ({
            ImageID: img.ImageID,

            original_file_path: img.original_file_path
          })),
          status: ['review', 'reviewed', 'cleaned', 'failed'][activeTab]
        });

        if (response.data.success) {
          // Remove deleted images from the current tab's state
          const deletedIds = new Set(selectedImages.map(img => img.ImageID));
          switch(activeTab) {
            case 0:
              setReviewImages(prev => prev.filter(img => !deletedIds.has(img.ImageID)));
              break;
            case 1:
              setReviewedImages(prev => prev.filter(img => !deletedIds.has(img.ImageID)));
              break;
            case 2:
              setCleanedImages(prev => prev.filter(img => !deletedIds.has(img.ImageID)));
              break;
            case 3:
              setFailedImages(prev => prev.filter(img => !deletedIds.has(img.ImageID)));
              break;
          }
          
          // Clear selection
          setSelectedImages([]);

          toast.current?.show({
            severity: 'success',
            summary: 'Success',
            detail: response.data.message,
            life: 3000,
          });
        }
      } catch (error) {
        console.error('Delete error:', error);
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete images',
          life: 3000,
        });
      } finally {
        setDeletingImages(false);
      }
    }
  });
};

const getImageTypeCodeBulk = async (images: Array<{
  imageType: string,
  basePath: string,
  subfolderPath: string,
  currentFileName: string
}>): Promise<{ [key: string]: string }> => {
  // First handle all standard image types
  const results: { [key: string]: string } = {};
  const extraTypesNeeded: Array<{
    key: string,
    filePath: string,
    fileName: string
  }> = [];

  // Process standard types first
  images.forEach(({ imageType, basePath, subfolderPath, currentFileName }, index) => {
    const key = `${index}`;
    if (imageType in IMAGE_TYPE_MAPPING) {
      results[key] = IMAGE_TYPE_MAPPING[imageType as keyof typeof IMAGE_TYPE_MAPPING];
    } else {
      extraTypesNeeded.push({
        key,
        filePath: `${basePath}/${subfolderPath}`,
        fileName: currentFileName
      });
    }
  });

  // If we have any extra types, process them in batches of 10
  if (extraTypesNeeded.length > 0) {
    const BATCH_SIZE = 200;
    
    // Split extraTypesNeeded into batches
    for (let i = 0; i < extraTypesNeeded.length; i += BATCH_SIZE) {
      const batch = extraTypesNeeded.slice(i, i + BATCH_SIZE);
      
      try {
        const response = await axios.post(
          `${API_URL}/api/product-images/reviewer/get-extra-image-types`,
          { images: batch }
        );

        if (response.data.success) {
          // Merge the results from this batch
          Object.assign(results, response.data.suffixes);
        } else {
          // Fallback to P04 for failed batch
          batch.forEach(({ key }) => {
            results[key] = 'P04';
          });
        }
      } catch (error) {
        console.error(`Error getting extra image type codes for batch ${i / BATCH_SIZE + 1}:`, error);
        // Fallback to P04 for failed batch
        batch.forEach(({ key }) => {
          results[key] = 'P04';
        });
      }
    }
  }

  return results;
};


  // Update the generateImageData function signature to accept string values instead of ImageCategory/ImageType objects
  const generateImageMetadata = async (
    images: LoadedImageMetadata[], 
    categoryInput: string | null | undefined, 
    typeInput: string | null | undefined,
    baseFileNameInput: string | null | undefined
  ): Promise<GeneratedImageMetadata[]> => {
    console.log(`categoryInput: ${categoryInput}`);
    const getBaseFileName = (
      originalFileName: string, 
      userInput: string | null | undefined,
      imageCategory: string,
      brand?: string,
      model?: string
    ): string => {
      if (userInput) {
        if (imageCategory.toLowerCase() === 'lifestyle_image') {
          const validNames = [
            brand?.toUpperCase() || '',
            model?.toUpperCase() || ''
          ];
          
          if (!validNames.includes(userInput.toUpperCase())) {
            console.log('Base file name for lifestyle images should match either the brand or the model.');
            return 'Base file name for lifestyle images should match either the brand or the model.';
          }
        }
        return userInput;
      }
      
      // Default behavior for no user input
      return originalFileName.split('_').slice(0, -1).join('_');
    };
    
    const getFileExtension = (fileName: string): string => {
      return fileName.split('.').pop() || '';
    };

    const imageTypeRequests = images.map(image => {
      const imageType = typeInput || image.image_type || 'Extra';
      const imageCategory = categoryInput || image.image_category || 'product_image';
      const basePath = image.status === 'cleaned' ? BASE_SFTP_PROCESSED_PATH : BASE_SFTP_RAW_PATH;
      
      let subfolderPath = '';
      if (['product_image', 'product'].includes(imageCategory.toLowerCase().trim())) {
        subfolderPath = `product_images/${image.brand}/${image.upc}`;
      } else if (['lifestyle_image', 'lifestyle'].includes(imageCategory.toLowerCase().trim())) {
        const baseFileName = getBaseFileName(
          image.file_name,
          baseFileNameInput,
          imageCategory,
          image.brand,
          image.model
        );
        
        if (image.model?.toUpperCase() === baseFileName.toUpperCase()) {
          subfolderPath = `lifestyle_images/models/${image.model}`;
        } else if (image.brand?.toUpperCase() === baseFileName.toUpperCase()) {
          subfolderPath = `lifestyle_images/brands/${image.brand}`;
        }
      }
  
      return {
        imageType,
        basePath,
        subfolderPath,
        currentFileName: image.file_name
      };
    });
  
    // Get all image type codes in bulk
    const imageTypeCodes = await getImageTypeCodeBulk(imageTypeRequests);
  
    // Generate metadata for all images
    return images.map((image, index) => {
      const imageType = typeInput || image.image_type || 'Extra';
      const imageCategory = categoryInput || image.image_category || 'product_image';
      const fileExtension = getFileExtension(image.file_name);
      const baseFileName = getBaseFileName(
        image.file_name,
        baseFileNameInput,
        imageCategory,
        image.brand,
        image.model
      );
  
      const basePath = image.status === 'cleaned' ? BASE_SFTP_PROCESSED_PATH : BASE_SFTP_RAW_PATH;
      let subfolderPath = imageTypeRequests[index].subfolderPath;
  
      const imageTypeCode = imageTypeCodes[index.toString()];
      const generatedFileName = `${baseFileName}_${imageTypeCode}.${fileExtension}`;
      const generatedFilePath = `${basePath}/${subfolderPath}/${generatedFileName}`;
      const generatedUrl = encodeURI(generatedFilePath);
  
      return {
        ImageID: image.ImageID,
        URL: image.URL,
        status: image.status,
        original_file_path: image.original_file_path,
        image_width: image.ImageWidth,
        image_height: image.ImageHeight,
        brand: image.brand || 'N/A',
        model: image.model || 'N/A',
        color_code: image.color_code || 'N/A',
        upc: image.upc || 'N/A',
        size_code: image.size_code || 'N/A',
        generated_file_name: generatedFileName,
        generated_file_path: generatedFilePath,
        generated_url: generatedUrl,
        generated_image_number: imageTypeCode,
        image_category: categoryInput || image.image_category,
        generated_image_type: imageType,
      };
    });
  };
  

  const handleCategoryChange = (e: any) => {
    setSelectedCategory(e.value);
  };

  const handleTypeChange = (e: any) => {
    setSelectedType(e.value);
  };

  const handleBaseFileNameChange = (e: any) => {
    setBaseFileNameInput(e.target.value);
  };


  const handleSearch = async () => {
    if (!searchTerm.trim()) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please enter a search term',
        life: 3000,
      });
      return;
    }
  
    try {
      setSearchLoading(true);
      const response = await axios.post(`${API_URL}/api/product-images/reviewer/search-images`, {
        searchTerm,
        status: ['review', 'reviewed', 'cleaned', 'failed'][activeTab],
        hits: searchHits,
        imageType: searchImageType
      });
      
      if (response.data.success) {
        const newImages = response.data.images || [];

        // Update the current tab's image list based on activeTab
        switch(activeTab) {
          case 0:
            setReviewImages(prev => {
              const existingIds = new Set(prev.map(img => img.ImageID));
              const uniqueNewImages = newImages.filter(img => !existingIds.has(img.ImageID));
              return [...prev, ...uniqueNewImages];
            });
            break;
          case 1:
            setReviewedImages(prev => {
              const existingIds = new Set(prev.map(img => img.ImageID));
              const uniqueNewImages = newImages.filter(img => !existingIds.has(img.ImageID));
              return [...prev, ...uniqueNewImages];
            });
            break;
          case 2:
            setCleanedImages(prev => {
              const existingIds = new Set(prev.map(img => img.ImageID));
              const uniqueNewImages = newImages.filter(img => !existingIds.has(img.ImageID));
              return [...prev, ...uniqueNewImages];
            });
            break;
            case 3: // Add case for failed tab
            setFailedImages(prev => {
              const existingIds = new Set(prev.map(img => img.ImageID));
              const uniqueNewImages = newImages.filter(img => !existingIds.has(img.ImageID));
              return [...prev, ...uniqueNewImages];
            });
            break;
        }
  
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: `Found ${newImages.length} images`,
          life: 3000,
        });
      }
      setSearchLoading(false);
      setSearchTerm(''); // Clear search input after successful search
      setSearchDialogVisible(false); // Close the search dialog
    } catch (error) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to search images',
        life: 3000,
      });
      setSearchLoading(false);
    }
  };

  const fetchImages = useCallback(async (type: string, isLoadMore = false) => {
    try {
      if (isLoadMore) {
        setLoadingMore(true);
      } else {
        setLoading(true);
      }
  
      const response = await axios.get(
        `${API_URL}/api/product-images/reviewer/load-images`, {
          params: {
            type,

            offset: offsets[type as keyof typeof offsets], // Use the appropriate offset based on type
            limit: ROWS_PER_PAGE
          }
        }
      );
      
      if (response.data.success) {
        const newImages = response.data.images || [];
        setHasMore(prev => ({
          ...prev,
          [type]: newImages.length >= ROWS_PER_PAGE
        }));
  
        // Update the state without clearing existing images
        switch(type) {
          case 'review':
            setReviewImages(prev => {
              const existingIds = new Set(prev.map(img => img.ImageID));
              const uniqueNewImages = newImages.filter(
                img => !existingIds.has(img.ImageID)
              );
              return isLoadMore ? [...prev, ...uniqueNewImages] : newImages;
            });
            break;
          case 'reviewed':
            setReviewedImages(prev => {
              const existingIds = new Set(prev.map(img => img.ImageID));
              const uniqueNewImages = newImages.filter(
                img => !existingIds.has(img.ImageID)
              );
              return isLoadMore ? [...prev, ...uniqueNewImages] : newImages;
            });
            break;
          case 'cleaned':
            setCleanedImages(prev => {
              const existingIds = new Set(prev.map(img => img.ImageID));
              const uniqueNewImages = newImages.filter(
                img => !existingIds.has(img.ImageID)
              );
              return isLoadMore ? [...prev, ...uniqueNewImages] : newImages;
            });
            break;
          case 'failed': // Add case for failed images
            setFailedImages(prev => {
              const existingIds = new Set(prev.map(img => img.ImageID));
              const uniqueNewImages = newImages.filter(
                img => !existingIds.has(img.ImageID)
              );
              return isLoadMore ? [...prev, ...uniqueNewImages] : newImages;
            });
            break;
        }
      }
    } catch (error) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to load images',
        life: 3000,
      });
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  }, [offsets]);

  // Add loadMore function
  const loadMore = () => {
    const types = ['review', 'reviewed', 'cleaned', 'failed'];
    const currentType = types[activeTab];
    
    setOffsets(prev => ({
      ...prev,
      [currentType]: prev[currentType as keyof typeof prev] + ROWS_PER_PAGE
    }));
    
    fetchImages(currentType, true);
  };

  const handleTabChange = (e: { index: number }) => {
    setActiveTab(e.index);
    setSelectedImages([]); // Only clear selected images
    // No need to reset offsets here as we want to maintain them separately
  };

  

  const onSelectionChange = (e: any) => {
    setSelectedImages(e.value)
  }

  const handleKeepNewBulk = async () => {
    if (!currentDuplicate) return;
    
    try {
      setKeepingNewImage(true);
      
      // Prepare data for bulk endpoint
      const allDuplicateItems = [
        // Current duplicate
        {
          duplicateImageData: currentDuplicate.imageData,
          existingImageData: currentDuplicate.duplicateData
        },
        // Queue items - no need to fetch duplicate data, the backend will handle this
        ...duplicateQueue.map(queueItem => ({
          duplicateImageData: queueItem.imageData,
          existingImageData: {} // The backend will look this up
        }))
      ];
      
      // Process in batches of 50
      const BATCH_SIZE = 50;
      const processedImageIds = new Set();
      const updatedImages = new Map<number, any>();
      let successCount = 0;
      let totalProcessed = 0;
      
      // Split into batches and process each
      for (let i = 0; i < allDuplicateItems.length; i += BATCH_SIZE) {
        const batch = allDuplicateItems.slice(i, i + BATCH_SIZE);
        totalProcessed += batch.length;
        
        // Call the bulk endpoint for this batch
        const bulkResponse = await axios.post(
          `${API_URL}/api/product-images/reviewer/resolve-duplicates-bulk`,
          {
            duplicateItems: batch,
            action: 'keep_new',
            queryType: markAsReviewed ? 'mark_as_reviewed' : 'save'
          }
        );
  
        // Process successful results
        if (bulkResponse.data.results?.successful) {
          bulkResponse.data.results.successful.forEach((result: any) => {
            if (result.ImageID) processedImageIds.add(result.ImageID);
            successCount++;
            
            // Also track updated images
            if (result.updatedExistingImage) {
              updatedImages.set(result.updatedExistingImage.ImageID, result.updatedExistingImage);
            }
          });
        }
        
        // Process skipped results
        if (bulkResponse.data.results?.skipped) {
          bulkResponse.data.results.skipped.forEach((result: any) => {
            if (result.ImageID) processedImageIds.add(result.ImageID);
          });
        }
      }
      
      // Update selected images
      setSelectedImages(prev => prev
        .filter(img => !processedImageIds.has(img.ImageID))
        .map(img => updatedImages.has(img.ImageID) ? updatedImages.get(img.ImageID) : img)
      );
      
      // Update the current tab's images
      switch(activeTab) {
        case 0:
          setReviewImages(prev => prev
            .filter(img => !processedImageIds.has(img.ImageID))
            .map(img => updatedImages.has(img.ImageID) ? updatedImages.get(img.ImageID) : img)
          );
          break;
        case 1:
          setReviewedImages(prev => prev
            .filter(img => !processedImageIds.has(img.ImageID))
            .map(img => updatedImages.has(img.ImageID) ? updatedImages.get(img.ImageID) : img)
          );
          break;
        case 2:
          setCleanedImages(prev => prev
            .filter(img => !processedImageIds.has(img.ImageID))
            .map(img => updatedImages.has(img.ImageID) ? updatedImages.get(img.ImageID) : img)
          );
          break;
      }
      
      // Show success toast
      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: `Processed ${successCount} of ${totalProcessed} duplicates`,
        life: 3000,
      });
      
      // Clear the duplicate queue and close dialog
      setDuplicateQueue([]);
      setShowDuplicateDialog(false);
      
    } catch (error) {
      console.error('Error processing duplicates in bulk:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to process duplicates',
        life: 3000,
      });
    } finally {
      setKeepingNewImage(false);
    }
  };
  
  const handleKeepExistingBulk = async () => {
    if (!currentDuplicate) return;
  
    try {
      setKeepingOriginalImage(true);
      
      // Prepare data for bulk endpoint
      const allDuplicateItems = [
        // Current duplicate
        {
          duplicateImageData: currentDuplicate.imageData,
          existingImageData: currentDuplicate.duplicateData
        },
        // Queue items - no need to fetch duplicate data, the backend will handle this
        ...duplicateQueue.map(queueItem => ({
          duplicateImageData: queueItem.imageData,
          existingImageData: {} // The backend will look this up
        }))
      ];
      
      // Process in batches of 50
      const BATCH_SIZE = 50;
      const processedImageIds = new Set();
      const updatedImages = new Map<number, any>();
      let successCount = 0;
      let totalProcessed = 0;
      
      // Split into batches and process each
      for (let i = 0; i < allDuplicateItems.length; i += BATCH_SIZE) {
        const batch = allDuplicateItems.slice(i, i + BATCH_SIZE);
        totalProcessed += batch.length;
        
        // Call the bulk endpoint for this batch
        const bulkResponse = await axios.post(  
          `${API_URL}/api/product-images/reviewer/resolve-duplicates-bulk`,
          {
            duplicateItems: batch,
            action: 'keep_existing',
            queryType: markAsReviewed ? 'mark_as_reviewed' : 'save'
          }
        );
        
        // Process successful results
        if (bulkResponse.data.results?.successful) {
          bulkResponse.data.results.successful.forEach((result: any) => {
            if (result.ImageID) processedImageIds.add(result.ImageID);
            successCount++;
            
            // Also track updated images
            if (result.updatedExistingImage) {
              updatedImages.set(result.updatedExistingImage.ImageID, result.updatedExistingImage);
            }
          });
        }
        
        // Process skipped results
        if (bulkResponse.data.results?.skipped) {
          bulkResponse.data.results.skipped.forEach((result: any) => {
            if (result.ImageID) processedImageIds.add(result.ImageID);
          });
        }
      }
      
      // Update selected images
      setSelectedImages(prev => prev
        .filter(img => !processedImageIds.has(img.ImageID))
        .map(img => updatedImages.has(img.ImageID) ? updatedImages.get(img.ImageID) : img)
      );
      
      // Update the current tab's images
      switch(activeTab) {
        case 0:
          setReviewImages(prev => prev
            .filter(img => !processedImageIds.has(img.ImageID))
            .map(img => updatedImages.has(img.ImageID) ? updatedImages.get(img.ImageID) : img)
          );
          break;
        case 1:
          setReviewedImages(prev => prev
            .filter(img => !processedImageIds.has(img.ImageID))
            .map(img => updatedImages.has(img.ImageID) ? updatedImages.get(img.ImageID) : img)
          );
          break;
        case 2:
          setCleanedImages(prev => prev
            .filter(img => !processedImageIds.has(img.ImageID))
            .map(img => updatedImages.has(img.ImageID) ? updatedImages.get(img.ImageID) : img)
          );
          break;
      }
      
      // Show success toast
      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: `Processed ${successCount} of ${totalProcessed} duplicates`,
        life: 3000,
      });
      
      // Clear the duplicate queue and close dialog
      setDuplicateQueue([]);
      setShowDuplicateDialog(false);
      
    } catch (error) {
      console.error('Error processing duplicates in bulk:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to process duplicates',
        life: 3000,
      });
    } finally {
      setKeepingOriginalImage(false);
    }
  };


  const showNextDuplicate = async (duplicates: DuplicateResult[]) => {
    if (duplicates.length > 0) {
      const [firstDuplicate, ...remainingDuplicates] = duplicates;
      if (firstDuplicate.imageData) {
        try {
          setLoadingDuplicateData(true);
          setShowDuplicateDialog(true);
          setReviewDialogVisible(false);
          
          // Fetch duplicate data from the new endpoint
          const response = await axios.post(
            `${API_URL}/api/product-images/reviewer/get-duplicate-data`,
            { newData: firstDuplicate.imageData }
          );

          if (response.data.success) {
            setCurrentDuplicate({
              imageData: firstDuplicate.imageData,
              duplicateData: response.data.duplicateData
            });
            setDuplicateQueue(remainingDuplicates);
          } else {
            // Skip this duplicate if we can't fetch the data
            showNextDuplicate(remainingDuplicates);
          }
        } catch (error) {
          console.error('Error fetching duplicate data:', error);
          // Skip this duplicate if there's an error
          showNextDuplicate(remainingDuplicates);
        } finally {
          setLoadingDuplicateData(false);
        }
      } else {
        // Skip this duplicate if newData is missing
        showNextDuplicate(remainingDuplicates);
      }
    } else {
      // No more duplicates to process
      setShowDuplicateDialog(false);
      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: 'All duplicates have been processed',
        life: 3000,
      });
    }
  };

  const handleKeepNew = async () => {
    if (!currentDuplicate) return;
    
    try { 
      setKeepingNewImage(true);
      const response = await axios.post(`${API_URL}/api/product-images/reviewer/resolve-duplicate`, {
        duplicateImageData: currentDuplicate.imageData,
        existingImageData: currentDuplicate.duplicateData,
        action: 'keep_new',
        queryType: markAsReviewed ? 'mark_as_reviewed' : 'save'

      });
  
      if (response.data.success) {
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: response.data.message,
          life: 3000,
        });
  
        // Update the image in the appropriate list with the new data
        const updatedImage = response.data.updatedExistingImage;
        switch(activeTab) {
          case 0:
            setReviewImages(prev => 
              prev
                .filter(img => img.ImageID !== currentDuplicate.imageData.ImageID)
                .map(img => img.ImageID === updatedImage.ImageID ? updatedImage : img)
            );
            break;
          case 1:
            setReviewedImages(prev => 
              prev
                .filter(img => img.ImageID !== currentDuplicate.imageData.ImageID)
                .map(img => img.ImageID === updatedImage.ImageID ? updatedImage : img)
            );


            break;
          case 2:
            setCleanedImages(prev => 
              prev
                .filter(img => img.ImageID !== currentDuplicate.imageData.ImageID)
                .map(img => img.ImageID === updatedImage.ImageID ? updatedImage : img)
            );

            break;

        }
  
        // Update selected images if necessary
        setSelectedImages(prev => 
          prev
            .filter(img => img.ImageID !== currentDuplicate.imageData.ImageID)
            .map(img => img.ImageID === updatedImage.ImageID ? updatedImage : img)
        );


  
        // Show next duplicate
        showNextDuplicate(duplicateQueue);
      }
    } catch (error) {
      console.error('Error processing duplicate:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to process duplicate',
        life: 3000,
      });
    } finally {
      setKeepingNewImage(false);
    }
  };

  const handleKeepExisting = async () => {
    if (!currentDuplicate) return;
  
    try {
      setKeepingOriginalImage(true);
      const response = await axios.post(`${API_URL}/api/product-images/reviewer/resolve-duplicate`, {
        duplicateImageData: currentDuplicate.imageData,
        existingImageData: currentDuplicate.duplicateData,
        action: 'keep_existing',
        queryType: markAsReviewed ? 'mark_as_reviewed' : 'save'

      });
  
      if (response.data.success) {
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: response.data.message,
          life: 3000,
        });
  
        // Show next duplicate
        showNextDuplicate(duplicateQueue);
      }
    } catch (error) {
      console.error('Error processing duplicate:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to process duplicate',
        life: 3000,
      });
    } finally {
      setKeepingOriginalImage(false);
      
      // Remove the processed image from selected images
      setSelectedImages(prev => 
        prev.filter(img => img.ImageID !== currentDuplicate.imageData.ImageID &&
          img.ImageID !== currentDuplicate.duplicateData.ImageID
        )
      );
  
      // Remove the processed image from the current tab's image list
      switch(activeTab) {
        case 0:
          setReviewImages(prev => 
            prev.filter(img => img.ImageID !== currentDuplicate.imageData.ImageID &&
              img.ImageID !== currentDuplicate.duplicateData.ImageID
            )
          );
          break;
        case 1:
          setReviewedImages(prev => 
            prev.filter(img => img.ImageID !== currentDuplicate.imageData.ImageID &&
              img.ImageID !== currentDuplicate.duplicateData.ImageID
            )
          );
          break;
        case 2:
          setCleanedImages(prev => 
            prev.filter(img => img.ImageID !== currentDuplicate.imageData.ImageID &&
              img.ImageID !== currentDuplicate.duplicateData.ImageID
            )
          );
          break;
      }
    }
  };

  const handleReview = async () => {
    if (selectedImages.length === 0) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select at least one image to review',
        life: 3000,
      });
      return;
    }

    // Check if we're trying to review failed images
    if (isFailedTab) {
          toast.current?.show({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed images cannot be reviewed',
            life: 3000,
          });
          return;
    }

    try {
      setReviewLoading(true);
      // Generate metadata for all selected images
      const generatedMetadata = await generateImageMetadata(
        selectedImages,
        selectedCategory,
        selectedType,
        baseFileNameInput
      );
      setReviewMetadata(generatedMetadata);
      setReviewDialogVisible(true);
    } catch (error) {
      console.error('Error generating metadata:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to generate metadata for review',
        life: 3000,
      });
    } finally {
      setReviewLoading(false);
    }
  };

  const handleApplyChanges = async () => {
    try {
      setApplyingChanges(true);
      
      // Process images in batches of 100
      const BATCH_SIZE = 100;
      const batches: GeneratedImageMetadata[][] = [];
      
      // Split reviewMetadata into batches
      for (let i = 0; i < reviewMetadata.length; i += BATCH_SIZE) {
        batches.push(reviewMetadata.slice(i, i + BATCH_SIZE));
      }
      
      // Process each batch sequentially
      let successfulImageIds = new Set();
      let duplicatesQueue: DuplicateResult[] = [];
      
      for (let batch of batches) {
        const response = await axios.post(`${API_URL}/api/product-images/reviewer/update-images`, {
          images: batch,
          queryType: markAsReviewed ? 'mark_as_reviewed' : 'save',
          ignoreDuplicates
        });
  
        if (response.data.success) {
          // Add successfully processed image IDs to the set
          batch.forEach(img => successfulImageIds.add(img.ImageID));
          
        } else if (response.data.duplicate_found && !ignoreDuplicates) {
          // Add successful IDs from this batch
          response.data.results.successful?.forEach((result: any) => {
            successfulImageIds.add(result.ImageID);
          });
          
          // Add duplicates to the queue
          duplicatesQueue = [...duplicatesQueue, ...response.data.results.duplicates];
        } else if (response.data.duplicate_found && ignoreDuplicates) {
          // Add successful IDs from this batch when ignoring duplicates
          response.data.results.successful?.forEach((result: any) => {
            successfulImageIds.add(result.ImageID);
          });
        }
      }
  
      // After all batches are processed, update UI
      if (duplicatesQueue.length > 0 && !ignoreDuplicates) {
        // Remove successful images from selected images
        setSelectedImages(prev => prev.filter(img => !successfulImageIds.has(img.ImageID)));
  
        // Remove successful images from the current tab's images
        switch(activeTab) {
          case 0:
            setReviewImages(prev => prev.filter(img => !successfulImageIds.has(img.ImageID)));
            break;
          case 1:
            setReviewedImages(prev => prev.filter(img => !successfulImageIds.has(img.ImageID)));
            break;
          case 2:
            setCleanedImages(prev => prev.filter(img => !successfulImageIds.has(img.ImageID)));
            break;
        }
  
        console.log('duplicatesQueue', duplicatesQueue)
        // Set duplicate queue and show first duplicate
        setDuplicateQueue(duplicatesQueue);
        showNextDuplicate(duplicatesQueue);
        
      } else {
        // All images processed successfully or duplicates ignored
        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: `Successfully processed ${reviewMetadata.length} images`,
          life: 3000,
        });
  
        // Update local state and close review dialog
        if (markAsReviewed && activeTab === 0) {
          setReviewImages(prev => prev.filter(img => !successfulImageIds.has(img.ImageID)));
        }
  
        setSelectedImages(prev => prev.filter(img => !successfulImageIds.has(img.ImageID)));
        setReviewDialogVisible(false);
      }
  
    } catch (error) {
      console.error('Apply changes error:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to apply changes',
        life: 3000,
      });
    } finally {
      setApplyingChanges(false);
      setSelectedCategory(null);
      setSelectedType(null);
      setBaseFileNameInput('');
    }
  };


  return (
    <div className="product-images-reviewer card text-body bg-body">
      <Toast ref={toast} />
      <ConfirmDialog />
      <div className='card-header d-flex align-items-stretch'>
        <h2 className='card-title m-0 mb-0'>Product Images Reviewer</h2>
      </div>
      <div className="main-section p-3" style={{  borderRadius: '6px', marginBottom: '1rem' }}>
        <div className="grid pt-1">
          {/* Input Controls Row */}
          <div className="input-row col-12 md:col-4">
            <div className="p-fluid">
              <div className="mb-3">
                <span className="p-float-label">
                  <Dropdown
                    id="category"
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    options={categoryOptions}
                    optionLabel="label"
                    className="w-full"
                    disabled={selectedImages.length === 0}
                    placeholder="Keep Original Information"
                  />
                  <label htmlFor="category">Image Category</label>
                </span>
              </div>
              
              <div className="mb-3">
                <span className="p-float-label">
                  <Dropdown
                    id="type"
                    value={selectedType}
                    onChange={handleTypeChange}
                    options={typeOptions}
                    optionLabel="label"
                    className="w-full"
                    disabled={selectedImages.length === 0}
                    placeholder="Keep Original Information"
                  />
                  <label htmlFor="type">Image Type</label>
                </span>
              </div>
              
              <div className="mb-3">
                <span className="p-float-label">
                  <InputText
                    id="baseFileNameInput"
                    value={baseFileNameInput}
                    onChange={handleBaseFileNameChange}
                    className="w-full"
                    disabled={selectedImages.length === 0}
                    placeholder="Leave blank to keep original file names"
                  />
                  <label htmlFor="baseFileName">Base File Name</label>
                </span>
              </div>
  
              <div className="button-container">
                <Button
                  label={reviewLoading ? 'Preparing Review...' : applyingChanges ? 'Applying Changes...' : 'Review'}
                  icon="pi pi-eye"
                  disabled={selectedImages.length === 0 || applyingChanges}
                  onClick={handleReview}
                  className="mr-2"
                  loading={reviewLoading || applyingChanges}
                  tooltip={isFailedTab ? 'Failed images cannot be reviewed' : selectedImages.length === 0 ? 'Select images to review' : ''}
                  tooltipOptions={{ position: 'top' }}
                />
                <Button
                  label={deletingImages ? 'Deleting...' : 'Delete'}
                  icon="pi pi-trash"
                  severity="danger"
                  disabled={selectedImages.length === 0 || deletingImages}
                  onClick={handleDelete}
                  loading={deletingImages}
                />
              </div>
            </div>
          </div>
  
          {/* Preview Panel */}
          <div className="preview-panel col-12 md:col-8">
          <div className="preview-panel-header text-body bg-secondary">
            {selectedImages.length === 0 && 'No Images Selected'}
            {selectedImages.length === 1 && '1 Image Selected'}
            {selectedImages.length > 1 && `${selectedImages.length} Images Selected`}
          </div>
          <div className="preview-container" style={{ maxHeight: '500px', overflowY: 'auto' }}>
            {selectedImages.length === 0 ? (
              <div className="no-image-selected">Please select an image to review</div>
            ) : selectedImages.length === 1 ? (
              <div className="single-image-container">
                <Button 
                  icon="pi pi-times" 
                  className="remove-button"
                  onClick={() => setSelectedImages([])}
                  severity="danger"
                />
                <img 
                  src={(() => {
                    const image = selectedImages[0];
                    const hasProtocol = image.URL.startsWith('http://') || image.URL.startsWith('https://');
                    if (hasProtocol) return image.URL;
                    if (image.URL.startsWith('/')) return `${window.location.origin}${image.URL}`;
                    return `https://${image.URL}`;
                  })()} 
                  alt={selectedImages[0].file_name} 
                  className="preview-image"
                  onError={(e) => {
                    const img = e.currentTarget as HTMLImageElement;
                    if (!img.classList.contains('error-handled')) {
                      img.classList.add('error-handled');
                      img.src = IMAGE_NOT_FOUND_URL;
                      img.style.backgroundColor = '#f0f0f0';
                      img.style.objectFit = 'contain';
                      img.alt = 'Image Not Found';
                    }
                  }}
                />
              </div>
            ) : (
              <div className="thumbnails-grid">
                {selectedImages.map((image) => (
                  <div key={image.ImageID} className="thumbnail-container">
                    <Button 
                      icon="pi pi-times" 
                      className="remove-button"
                      onClick={() => {
                        setSelectedImages(selectedImages.filter(img => img.ImageID !== image.ImageID));
                      }}
                      severity="danger"
                    />
                    <img 
                      src={(() => {
                        const hasProtocol = image.URL.startsWith('http://') || image.URL.startsWith('https://');
                        if (hasProtocol) return image.URL;
                        if (image.URL.startsWith('/')) return `${window.location.origin}${image.URL}`;
                        return `https://${image.URL}`;
                      })()} 
                      alt={image.file_name} 
                      className="thumbnail-image"
                      onError={(e) => {
                        const img = e.currentTarget as HTMLImageElement;
                        if (!img.classList.contains('error-handled')) {
                          img.classList.add('error-handled');
                          img.src = IMAGE_NOT_FOUND_URL;
                          img.style.backgroundColor = '#f0f0f0';
                          img.style.objectFit = 'contain';
                          img.alt = 'Image Not Found';
                        }
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        </div>
      </div>
  
      <Dialog 
        header={`Search in ${['Review', 'Reviewed', 'Cleaned', 'Failed'][activeTab]} Images`}
        visible={searchDialogVisible} 
        onHide={() => setSearchDialogVisible(false)}
        style={{ width: '650px', maxWidth: '95vw' }}
        modal
        className="search-dialog"
      >
        <div className="search-form">
          <div className="search-header">
            Search by UPC or model number. Use semicolons (;) to search for multiple terms.
            For example: "8053672743838; RY1540" will find images matching either term.
          </div>
          
          <div className="search-row">
            <div className="search-input-wrapper">
              <InputText
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Enter UPC or model number..."
                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
              />
            </div>
            
            <Button
              icon="pi pi-search"
              onClick={() => {
                handleSearch();
                setSearchDialogVisible(false);
              }}
              loading={searchLoading}
              className="search-button"
              tooltip="Search"
            />
          </div>

          <div className="search-row">
            <div className="filter-wrapper">
              <Dropdown
                value={searchImageType}
                options={searchTypeOptions}
                onChange={(e) => setSearchImageType(e.value)}
                placeholder="Image Type"
              />
            </div>
            
            <div className="filter-wrapper">
              <Dropdown
                value={searchHits}
                options={hitsOptions}
                onChange={(e) => setSearchHits(e.value)}
                placeholder="Max results"
              />
            </div>
          </div>
        </div>
      </Dialog>
  
      <div className="images-table-section card p-0">
      <TabView data-testid="image-reviewer-tabs" className="ps-0" activeIndex={activeTab} onTabChange={handleTabChange}>
        <TabPanel data-testid="tab-review" style={{marginLeft:'-2rem'}} className="ps-0 pt-0" header="Review">
          <DataTable
            data-testid="images-table-review"
            value={reviewImages}
            loading={loading}
            scrollable
            scrollHeight='700px'
            className='mt-0 ms-8'
            style={{background: 'transparent'}}
            selection={selectedImages}
            onSelectionChange={onSelectionChange}
            selectionMode="multiple"
            dataKey="ImageID"
            paginator
            first={first}
            rows={rows}
            totalRecords={reviewImages.length}
            onPage={onPage}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          >
              <Column 
                selectionMode="multiple" 
                headerStyle={{width: '3rem'}}
                exportable={false}
              />
              <Column
                key='URL'
                field='URL'
                header='Preview'
                style={{width: '150px'}}
                body={(rowData) => {
                  if (rowData.URL) {
                    const hasProtocol = rowData.URL.startsWith('http://') || rowData.URL.startsWith('https://')
                    let fullUrl = ''
              
                    if (hasProtocol) {
                      fullUrl = rowData.URL
                    } else if (rowData.URL.startsWith('/')) {
                      fullUrl = `${window.location.origin}${rowData.URL}`
                    } else {
                      fullUrl = `https://${rowData.URL}`
                    }
              
                    return (
                      <img 
                        src={fullUrl}
                        alt={rowData.file_name}
                        style={{width: '150px', height: '75px', objectFit: 'fill'}}
                        onError={(e) => {
                          const img = e.currentTarget as HTMLImageElement;
                          if (!img.classList.contains('error-handled')) {
                            img.classList.add('error-handled');
                            img.src = IMAGE_NOT_FOUND_URL;
                            img.style.backgroundColor = '#f0f0f0';
                            img.style.objectFit = 'contain';
                            img.alt = 'Image Not Found';
                          }
                        }}
                      />
                    )
                  }
                  return null
                }}
              />
              <Column field="image_type" header="Image Type" sortable filter />
              <Column field="image_category" header="Image Category" sortable filter />
              <Column field="brand" header="Brand" />
              <Column field="model" header="Model" />
              <Column field="upc" header="UPC" sortable filter />
              <Column field="file_name" header="File Name" sortable filter />
              <Column field="color" header="Color" sortable filter />
              <Column field="color_code" header="Color Code" sortable filter />
              <Column field="size" header="Size" sortable filter />
              <Column field="size_code" header="Size Code" sortable filter />
            </DataTable>
            <div className="flex justify-content-center align-items-center mt-3 mb-3">
              <div className="button-container">
                <Button 
                  data-testid="search-images-button"
                  label={searchLoading ? 'Searching...' : 'Search Images'}
                  icon="pi pi-search"
                  onClick={() => setSearchDialogVisible(true)}
                  className="p-button-outlined"
                  style={{ marginRight: '0.5rem' }}
                  loading={searchLoading}
                />
                <Button 
                  data-testid="load-more-button"
                  label={loadingMore ? 'Loading More Images...' : 'Load More Images'} 
                  icon="pi pi-plus"
                  loading={loadingMore}
                  onClick={loadMore}
                  className="p-button-outlined"
                />
              </div>
            </div>
          </TabPanel>
  
          <TabPanel data-testid="tab-reviewed" header="Reviewed">
            <DataTable
              data-testid="images-table-reviewed"
              value={reviewedImages}
              loading={loading}
              scrollable
              scrollHeight='700px'
              className='mt-1'
              style={{background: 'transparent'}}
              selection={selectedImages}
              onSelectionChange={onSelectionChange}
              selectionMode="multiple"
              dataKey="ImageID"
              paginator
              first={first}
              rows={rows}
              totalRecords={totalRecords.reviewed}
              onPage={onPage}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            >
              <Column 
                selectionMode="multiple" 
                headerStyle={{width: '3rem'}}
                exportable={false}
              />
              <Column
                key='URL'
                field='URL'
                header='Preview'
                style={{width: '150px'}}
                body={(rowData) => {
                  if (rowData.URL) {
                    const hasProtocol = rowData.URL.startsWith('http://') || rowData.URL.startsWith('https://')
                    let fullUrl = ''
              
                    if (hasProtocol) {
                      fullUrl = rowData.URL
                    } else if (rowData.URL.startsWith('/')) {
                      fullUrl = `${window.location.origin}${rowData.URL}`
                    } else {
                      fullUrl = `https://${rowData.URL}`
                    }
              
                    return (
                      <img 
                        src={fullUrl}
                        alt={rowData.file_name}
                        style={{width: '150px', height: '75px', objectFit: 'fill'}}
                        onError={(e) => {
                          const img = e.currentTarget as HTMLImageElement;
                          if (!img.classList.contains('error-handled')) {
                            img.classList.add('error-handled');
                            img.src = IMAGE_NOT_FOUND_URL;
                            img.style.backgroundColor = '#f0f0f0';
                            img.style.objectFit = 'contain';
                            img.alt = 'Image Not Found';
                          }
                        }}
                      />
                    )
                  }
                  return null
                }}
              />
              <Column field="image_type" header="Image Type" sortable filter />
              <Column field="image_category" header="Image Category" sortable filter />
              <Column field="brand" header="Brand" />
              <Column field="model" header="Model" />
              <Column field="upc" header="UPC" />
              <Column field="file_name" header="File Name" sortable filter />
              <Column field="color" header="Color" sortable filter />
              <Column field="color_code" header="Color Code" sortable filter />
              <Column field="size" header="Size" sortable filter />
              <Column field="size_code" header="Size Code" sortable filter />
            </DataTable>
            <div className="flex justify-content-center align-items-center mt-3 mb-3">
              <div className="button-container">
                <Button 
                  data-testid="search-images-button"
                  label={searchLoading ? 'Searching...' : 'Search Images'}
                  icon="pi pi-search"
                  onClick={() => setSearchDialogVisible(true)}
                  className="p-button-outlined"
                  style={{ marginRight: '0.5rem' }}
                  loading={searchLoading}
                />
                <Button 
                  data-testid="load-more-button"
                  label="Load More Images" 
                  icon="pi pi-plus"
                  loading={loadingMore}
                  onClick={loadMore}
                  className="p-button-outlined"
                />
              </div>
            </div>
          </TabPanel>
  
          <TabPanel data-testid="tab-cleaned" header="Cleaned">
            <DataTable
              data-testid="images-table-cleaned"
              value={cleanedImages}
              loading={loading}
              scrollable
              scrollHeight='700px'
              className='mt-1'
              style={{background: 'transparent'}}
              selection={selectedImages}
              onSelectionChange={onSelectionChange}
              selectionMode="multiple"
              dataKey="ImageID"
              paginator
              first={first}
              rows={rows}
              totalRecords={totalRecords.cleaned}
              onPage={onPage}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            >
              <Column 
                selectionMode="multiple" 
                headerStyle={{width: '3rem'}}
                exportable={false}
              />
              <Column
                key='URL'
                field='URL'
                header='Preview'
                style={{width: '150px'}}
                body={(rowData) => {
                  if (rowData.URL) {
                    const hasProtocol = rowData.URL.startsWith('http://') || rowData.URL.startsWith('https://')
                    let fullUrl = ''
              
                    if (hasProtocol) {
                      fullUrl = rowData.URL
                    } else if (rowData.URL.startsWith('/')) {
                      fullUrl = `${window.location.origin}${rowData.URL}`
                    } else {
                      fullUrl = `https://${rowData.URL}`
                    }
              
                    return (
                      <img 
                        src={fullUrl}
                        alt={rowData.file_name}
                        style={{width: '150px', height: '75px', objectFit: 'fill'}}
                        onError={(e) => {
                          const img = e.currentTarget as HTMLImageElement;
                          if (!img.classList.contains('error-handled')) {
                            img.classList.add('error-handled');
                            img.src = IMAGE_NOT_FOUND_URL;
                            img.style.backgroundColor = '#f0f0f0';
                            img.style.objectFit = 'contain';
                            img.alt = 'Image Not Found';
                          }
                        }}
                      />
                    )
                  }
                  return null
                }}
              />
              <Column field="image_type" header="Image Type" sortable filter />
              <Column field="image_category" header="Image Category" sortable filter />
              <Column field="upc" header="UPC" />
              <Column field="brand" header="Brand" />
              <Column field="model" header="Model" />
              <Column field="file_name" header="File Name" sortable filter />
              <Column field="color" header="Color" sortable filter />
              <Column field="color_code" header="Color Code" sortable filter />
              <Column field="size" header="Size" sortable filter />
              <Column field="size_code" header="Size Code" sortable filter />
            </DataTable>
            <div className="flex justify-content-center align-items-center mt-3 mb-3">
              <div className="button-container">
                <Button 
                  data-testid="search-images-button"
                  label={searchLoading ? 'Searching...' : 'Search Images'}
                  icon="pi pi-search"
                  onClick={() => setSearchDialogVisible(true)}
                  className="p-button-outlined"
                  style={{ marginRight: '0.5rem' }}
                  loading={searchLoading}
                />
                <Button 
                  data-testid="load-more-button"
                  label="Load More Images" 
                  icon="pi pi-plus"
                  loading={loadingMore}
                  onClick={loadMore}
                  className="p-button-outlined"
                />
              </div>
            </div>
          </TabPanel>
          <TabPanel data-testid="tab-failed" header="Failed">
            <DataTable
              data-testid="images-table-failed"
              value={failedImages}
              loading={loading}
              scrollable
              scrollHeight='700px'
              className='mt-1'
              style={{background: 'transparent'}}
              selection={selectedImages}
              onSelectionChange={onSelectionChange}
              selectionMode="multiple"
              dataKey="ImageID"
              paginator
              first={first}
              rows={rows}
              totalRecords={totalRecords.failed}
              onPage={onPage}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            >
              <Column 
                selectionMode="multiple" 
                headerStyle={{width: '3rem'}}
                exportable={false}
              />
              <Column
                key='URL'
                field='URL'
                header='Preview'
                style={{width: '150px'}}
                body={(rowData) => {
                  if (rowData.URL) {
                    const hasProtocol = rowData.URL.startsWith('http://') || rowData.URL.startsWith('https://')
                    let fullUrl = ''
              
                    if (hasProtocol) {
                      fullUrl = rowData.URL
                    } else if (rowData.URL.startsWith('/')) {
                      fullUrl = `${window.location.origin}${rowData.URL}`
                    } else {
                      fullUrl = `https://${rowData.URL}`
                    }
              
                    return (
                      <img 
                        src={fullUrl}
                        alt={rowData.file_name}
                        style={{width: '150px', height: '75px', objectFit: 'fill'}}
                        onError={(e) => {
                          const img = e.currentTarget as HTMLImageElement;
                          if (!img.classList.contains('error-handled')) {
                            img.classList.add('error-handled');
                            img.src = IMAGE_NOT_FOUND_URL;
                            img.style.backgroundColor = '#f0f0f0';
                            img.style.objectFit = 'contain';
                            img.alt = 'Image Not Found';
                          }
                        }}
                      />
                    )
                  }
                  return null
                }}
              />
              <Column 
                field="error_reason" 
                header="Error Reason" 
                sortable 
                filter
                style={{minWidth: '200px'}}
              />
              <Column field="image_type" header="Image Type" sortable filter />
              <Column field="image_category" header="Image Category" sortable filter />
              <Column field="brand" header="Brand" />
              <Column field="model" header="Model" />
              <Column field="upc" header="UPC" />
              <Column field="file_name" header="File Name" sortable filter />
              <Column field="color" header="Color" sortable filter />
              <Column field="color_code" header="Color Code" sortable filter />
              <Column field="size" header="Size" sortable filter />
              <Column field="size_code" header="Size Code" sortable filter />
            </DataTable>
            <div className="flex justify-content-center align-items-center mt-3 mb-3">
              <div className="button-container">
                <Button 
                  data-testid="search-images-button"
                  label={searchLoading ? 'Searching...' : 'Search Images'}
                  icon="pi pi-search"
                  onClick={() => setSearchDialogVisible(true)}
                  className="p-button-outlined"
                  style={{ marginRight: '0.5rem' }}
                  loading={searchLoading}
                />
                <Button 
                  data-testid="load-more-button"
                  label={loadingMore ? 'Loading More Images...' : 'Load More Images'} 
                  icon="pi pi-plus"
                  loading={loadingMore}
                  onClick={loadMore}
                  className="p-button-outlined"
                />
              </div>
            </div>
          </TabPanel>
        </TabView>
      </div>
      <Dialog
      header="Review Changes"
      visible={reviewDialogVisible}
      style={{ width: '90vw' }}
      modal
      onHide={() => setReviewDialogVisible(false)}
      footer={
        <div className="review-dialog-footer">
          <div className="checkbox-group">
          <div className="checkbox-item">
              <Checkbox
                inputId="markAsReviewed"
                checked={markAsReviewed}
                onChange={e => setMarkAsReviewed(!!e.checked)}
              /> 
              <label htmlFor="markAsReviewed">Mark as Reviewed</label>
            </div>
            <div className="checkbox-item">
              <Checkbox
                inputId="ignoreDuplicates"
                checked={ignoreDuplicates}
                onChange={e => setIgnoreDuplicates(!!e.checked)}
              />
              <label htmlFor="ignoreDuplicates">Ignore Duplicates</label>
            </div>
          </div>
          <div className="button-group">
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={() => setReviewDialogVisible(false)}
              className="cancel-button"
            />
            <Button
              label={applyingChanges ? 'Applying Changes...' : 'Apply Changes'}
              icon="pi pi-check"
              onClick={handleApplyChanges}
              className="apply-button"
              autoFocus
              loading={applyingChanges}
            />
          </div>
        </div>
      }
    >
      <DataTable
          value={reviewMetadata}
          scrollable
          scrollHeight="60vh"
          loading={reviewLoading}
        >
          <Column
                key='URL'
                field='URL'
                header='Preview'
                style={{width: '150px'}}
                body={(rowData) => {
                  if (rowData.URL) {
                    const hasProtocol = rowData.URL.startsWith('http://') || rowData.URL.startsWith('https://')
                    let fullUrl = ''
              
                    if (hasProtocol) {
                      fullUrl = rowData.URL
                    } else if (rowData.URL.startsWith('/')) {
                      fullUrl = `${window.location.origin}${rowData.URL}`
                    } else {
                      fullUrl = `https://${rowData.URL}`
                    }
              
                    return (
                      <img 
                        src={fullUrl}
                        alt={rowData.file_name}
                        style={{width: '150px', height: '75px', objectFit: 'fill'}}
                        onError={(e) => {
                          const img = e.currentTarget as HTMLImageElement;
                          if (!img.classList.contains('error-handled')) {
                            img.classList.add('error-handled');
                            img.src = IMAGE_NOT_FOUND_URL;
                            img.style.backgroundColor = '#f0f0f0';
                            img.style.objectFit = 'contain';
                            img.alt = 'Image Not Found';
                          }
                        }}
                      />
                    )
                  }
                  return null
                }}
              />
          <Column field="generated_image_type" header="New Image Type" />
          <Column field="generated_image_number" header="New Image Number" />
          <Column field="image_category" header="New Category" />
          <Column field="generated_file_name" header="New File Name" />
          <Column field="brand" header="Brand" />
          <Column field="model" header="Model" />
          <Column field="upc" header="UPC" />
          <Column field="color_code" header="Color Code" />
          <Column field="size_code" header="Size Code" />
          <Column
            header="Actions"
            body={(rowData) => (
              <Button
                icon="pi pi-trash"
                severity="danger"
                rounded
                text
                onClick={() => {
                  setReviewMetadata(prev => prev.filter(item => item.ImageID !== rowData.ImageID));
                  setSelectedImages(prev => prev.filter(item => item.ImageID !== rowData.ImageID));
                }}
                tooltip="Remove from selection"
                tooltipOptions={{ position: 'left' }}
              />
            )}
            style={{ width: '100px', textAlign: 'center' }}
          />
        </DataTable>
    </Dialog>

    <Dialog
  visible={showDuplicateDialog}
  onHide={() => setShowDuplicateDialog(false)}
  header="Duplicate Image Found"
  style={{ width: '90vw' }}
  modal
>
  {currentDuplicate && (
    <div className="duplicate-comparison">
      <h4 className="text-center mb-4">A File With Similar Data Already Exists. Please Choose Which Version To Keep:</h4>
      <div style={{ display: 'flex', gap: '2rem' }}>
        {/* Left side - New Image (Instant Load) */}
        <div style={{ flex: 1, backgroundColor: 'var(--surface-card)', padding: '1.5rem', borderRadius: '6px' }}>
          <h3 className="text-xl mb-3">New Image</h3>
          <div style={{ 
            backgroundColor: 'var(--surface-ground)', 
            padding: '1rem', 
            borderRadius: '6px',
            marginBottom: '1rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '300px'
          }}>
            <img 
              src={(() => {
                const url = currentDuplicate.imageData.URL;
                const hasProtocol = url.startsWith('http://') || url.startsWith('https://');
                if (hasProtocol) return url;
                if (url.startsWith('/')) return `${window.location.origin}${url}`;
                return `https://${url}`;
              })()}
              alt="New version"
              style={{ maxHeight: '300px', maxWidth: '100%', objectFit: 'contain' }}
            />
          </div>
          <div style={{ backgroundColor: 'var(--surface-section)', padding: '1rem', borderRadius: '6px' }}>
            <p className="mb-2"><strong>Filename:</strong> {currentDuplicate.imageData.generated_file_name}</p>
            <p className="mb-2"><strong>Brand:</strong> {currentDuplicate.imageData.brand}</p>
            <p className="mb-2"><strong>Model:</strong> {currentDuplicate.imageData.model}</p>
            <p className="mb-2"><strong>Status:</strong> {currentDuplicate.imageData.status}</p>
          </div>
        </div>

        {/* Right side - Existing Image (Loading State) */}
        <div style={{ flex: 1, backgroundColor: 'var(--surface-card)', padding: '1.5rem', borderRadius: '6px' }}>
          <h3 className="text-xl mb-3">Existing Image</h3>
          <div style={{ 
            backgroundColor: 'var(--surface-ground)', 
            padding: '1rem', 
            borderRadius: '6px',
            marginBottom: '1rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '300px'
          }}>
            {loadingDuplicateData ? (
              <div className="text-center">
                <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem', marginBottom: '1rem' }}></i>
                <div>Loading image...</div>
              </div>
            ) : (
              <img 
                src={(() => {
                  const url = currentDuplicate.duplicateData.URL;
                  const hasProtocol = url.startsWith('http://') || url.startsWith('https://');
                  if (hasProtocol) return url;
                  if (url.startsWith('/')) return `${window.location.origin}${url}`;
                  return `https://${url}`;
                })()}
                alt="Existing version"
                style={{ maxHeight: '300px', maxWidth: '100%', objectFit: 'contain' }}
              />
            )}
          </div>
          <div style={{ backgroundColor: 'var(--surface-section)', padding: '1rem', borderRadius: '6px' }}>
            {loadingDuplicateData ? (
              <div className="text-center p-3">
                <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem', marginBottom: '0.5rem' }}></i>
                <div>Loading metadata...</div>
              </div>
            ) : (
              <>
                <p className="mb-2"><strong>Filename:</strong> {currentDuplicate.duplicateData.file_name}</p>
                <p className="mb-2"><strong>Brand:</strong> {currentDuplicate.duplicateData.brand}</p>
                <p className="mb-2"><strong>Model:</strong> {currentDuplicate.duplicateData.model}</p>
                <p className="mb-2"><strong>Status:</strong> {currentDuplicate.duplicateData.status || 'N/A'}</p>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-content-center gap-3 mt-4" style={{ 
  display: 'flex',
  justifyContent: 'center',
  gap: '1rem',
  marginTop: '2rem'
}}>
  <div className="flex align-items-center" style={{ marginRight: '1rem' }}>
    <Checkbox
      checked={applyToAllDuplicates}
      onChange={() => setApplyToAllDuplicates(!applyToAllDuplicates)}
      id="applyToAllDuplicates"
    />
    <label htmlFor="applyToAllDuplicates" className="ml-2">Apply To All Duplicates</label>
  </div>
  <Button
    label={keepingNewImage ? 'Keeping New Image...' : 'Keep New Image'}
    icon="pi pi-check"
    severity="success"
    style={{ borderRadius: '4px' }}
    onClick={applyToAllDuplicates ? handleKeepNewBulk : handleKeepNew}
    loading={keepingNewImage}
    disabled={keepingNewImage || keepingOriginalImage || loadingDuplicateData}
  />
  <Button
    label={keepingOriginalImage ? 'Keeping Existing Image...' : 'Keep Existing Image'}
    icon="pi pi-check"
    severity="info"
    style={{ borderRadius: '4px' }}
    onClick={applyToAllDuplicates ? handleKeepExistingBulk : handleKeepExisting}
    loading={keepingOriginalImage}
    disabled={keepingOriginalImage || keepingNewImage || loadingDuplicateData}
  />
  <Button
    label="Do Nothing"
    icon="pi pi-times"
    severity="danger"
    style={{ borderRadius: '4px' }}
    onClick={() => {
      if (applyToAllDuplicates) {
        // Clear all duplicates and close dialog
        setDuplicateQueue([]);
        setShowDuplicateDialog(false);
      } else {
        // Show next duplicate
        showNextDuplicate(duplicateQueue);
      }
    }}
    disabled={keepingOriginalImage || keepingNewImage || loadingDuplicateData}
  />
</div>
    </div>
  )}
</Dialog>

    </div>
  );
};

export const ProductImagesReviewerWrapper: FC = () => {
  return (
    <>
      <ProductImagesReviewer />
    </>
  );
};

export default ProductImagesReviewerWrapper;